import React, { HTMLAttributes } from "react";
import classNames from "classnames";

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const Container: React.FC<ContainerProps> = ({ className, ...extraProps }) => {
  return (
    <div
      className={classNames(
        "mx-auto max-w-7xl px-4 py-2",
        className
      )}
      {...extraProps}
    />
  );
};
